import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

const buildFilterString = (company, viewer) => {
    const filterArray = [];

    // Active Only
    const activeFilter = 'NOT status:Inactive';
    filterArray.push(activeFilter);

    // Saved Searches for "Finding Space"
    const savedSearchFilter = 'savedSearch.primaryInterest:space';
    filterArray.push(savedSearchFilter);

    // Only Members affiliated with this Company
    const companyFilter = company.recordId ? `companyId:${company.recordId}` : '';
    if (companyFilter) filterArray.push(companyFilter);

    // Not the Member themselves
    const memberFilter = viewer.recordId ? `NOT memberId:${viewer.recordId}` : '';
    if (memberFilter) filterArray.push(memberFilter);

    const filterStr = filterArray.filter(f => f).join(' AND ');
    return filterStr;
};

const useCompanyProfileFeaturedSiteCriteriaFilterString = ({ company, viewer }) => {
    const [filterString, setFilterString] = useState('');

    useEffect(() => {
        if (!company || !viewer) {
            return;
        }

        const str = buildFilterString(company, viewer);
        if (str) setFilterString(str);
    }, [company, filterString, viewer]);

    return filterString;
};

useCompanyProfileFeaturedSiteCriteriaFilterString.propTypes = {
    company: PropTypes.object,
    viewer: PropTypes.object,
};

export default useCompanyProfileFeaturedSiteCriteriaFilterString;
